var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ShowingStandContainer"},_vm._l((_vm.array),function(item,index){return _c('div',{key:index,staticClass:"ShowingStand"},[_c('div',{staticClass:"tag"},[_vm._v(_vm._s(item.title)+" ")]),_c('img',{staticClass:"mainPic",attrs:{"src":item.src}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-282ef66a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/homepage/childComps/ShowingStand.vue
// module id = null
// module chunks = 